import React from 'react';

import SelectAllItemsControls from '@Containers/ResultToolbar/SelectedItemsControls/SelectAllItemsControls';
import ExportButton from '../ExportButton';
import LimitToButton from '../LimitToButton';
import ExcludeButton from '../ExcludeButton';
import ExportChemquoteButton from '../ExportChemquoteButton';
import ShowAllPreparationsButton from '../ShowAllPreparationsButton';
import ToggleConditionsButton from '../ToggleConditionsButton';

export default function ResultToolbarBottomLeftControls(props) {
  return (
    <section className="result-toolbar-bottom-left-controls">
      <SelectAllItemsControls {...props} />
      <LimitToButton {...props} />
      <ExcludeButton {...props} />
      <ExportButton {...props} />
      <ExportChemquoteButton {...props} />
      <ShowAllPreparationsButton {...props} />
      <ToggleConditionsButton {...props} />
    </section>
  );
}

ResultToolbarBottomLeftControls.propTypes = {};
